<template>
  <form class="mx-0 flex flex-wrap" @submit.prevent="createChannel()">
    <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
      <label :class="{ error: $v.inboxName.$error }">
        {{ $t('INBOX_MGMT.ADD.SMS.LABSMOBILE.INBOX_NAME.LABEL') }}
        <input
          v-model.trim="inboxName"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.SMS.LABSMOBILE.INBOX_NAME.PLACEHOLDER')"
          @blur="$v.inboxName.$touch"
        />
        <span v-if="$v.inboxName.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.SMS.LABSMOBILE.INBOX_NAME.ERROR') }}
        </span>
      </label>
    </div>

    <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
      <label :class="{ error: $v.sender.$error }">
        {{ $t('INBOX_MGMT.ADD.SMS.LABSMOBILE.SENDER.LABEL') }}
        <input
          v-model.trim="sender"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.SMS.LABSMOBILE.SENDER.PLACEHOLDER')"
          @blur="$v.sender.$touch"
        />
        <span v-if="$v.sender.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.SMS.LABSMOBILE.SENDER.ERROR') }}
        </span>
      </label>
    </div>

    <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
      <label :class="{ error: $v.username.$error }">
        {{ $t('INBOX_MGMT.ADD.SMS.LABSMOBILE.USERNAME.LABEL') }}
        <input
          v-model.trim="username"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.SMS.LABSMOBILE.USERNAME.PLACEHOLDER')"
          @blur="$v.username.$touch"
        />
        <span v-if="$v.username.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.SMS.LABSMOBILE.USERNAME.ERROR') }}
        </span>
      </label>
    </div>

    <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
      <label :class="{ error: $v.password.$error }">
        {{ $t('INBOX_MGMT.ADD.SMS.LABSMOBILE.PASSWORD.LABEL') }}
        <input
          v-model.trim="password"
          type="password"
          :placeholder="$t('INBOX_MGMT.ADD.SMS.LABSMOBILE.PASSWORD.PLACEHOLDER')"
          @blur="$v.password.$touch"
        />
        <span v-if="$v.password.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.SMS.LABSMOBILE.PASSWORD.ERROR') }}
        </span>
      </label>
      <p class="text-sm text-slate-600 dark:text-slate-300 whitespace-pre-line mt-2">
        {{ $t('INBOX_MGMT.ADD.SMS.LABSMOBILE.PASSWORD.HELP') }}
      </p>
    </div>

    <div class="w-full">
      <woot-submit-button
        :loading="uiFlags.isCreating"
        :button-text="$t('INBOX_MGMT.ADD.SMS.LABSMOBILE.SUBMIT_BUTTON')"
      />
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import { required } from 'vuelidate/lib/validators';
import router from '../../../../index';

const validSender = (value = '') =>
  /^\+?\d{1,16}$/.test(value) || /^[A-Za-z0-9]{1,11}$/.test(value);

export default {
  mixins: [alertMixin],
  data() {
    return {
      inboxName: '',
      sender: '',
      username: '',
      password: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    inboxName: { required },
    sender: { required, validSender },
    username: { required },
    password: { required },
  },
  methods: {
    async createChannel() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      try {
        const smsChannel = await this.$store.dispatch('inboxes/createChannel', {
          name: this.inboxName,
          channel: {
            type: 'sms',
            provider: 'labsmobile',
            phone_number: this.sender,
            provider_config: {
              username: this.username,
              password: this.password,
            },
          },
        });

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: smsChannel.id,
          },
        });
      } catch (error) {
        this.showAlert(this.$t('INBOX_MGMT.ADD.SMS.API.ERROR_MESSAGE'));
      }
    },
  },
};
</script>
